import { SupplierOrdersPageTab } from 'interfaces';

export const supplierOrdersPageTabsWithNewOrderTag: SupplierOrdersPageTab[] = [
   'ALL',
   'WAITING',
   'DURING_BILLING',
];
